import { NgModule, CUSTOM_ELEMENTS_SCHEMA  } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { LayoutComponent } from './layout.component';
import { LayoutRoutingModule } from './layout-routing.module';
import { HeaderModule } from '../header/header.module';
import { AdminModule } from '../admin/admin.module';
import { DashboardModule } from '../dashboard/dashboard.module';
import { AsideModule } from '../aside/aside.module';
import { SharedModule } from '../shared/shared.module';





@NgModule({
    imports: [
        CommonModule,
        LayoutRoutingModule,
        HeaderModule,
        AdminModule,
        DashboardModule,
        AsideModule,
        SharedModule,
        LayoutComponent
    ],
    exports: [
        RouterModule,
        LayoutComponent
    ],
    providers: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class LayoutModule { }
